import { render, staticRenderFns } from "./VActivate.vue?vue&type=template&id=304041ec&"
import script from "./VActivate.vue?vue&type=script&lang=js&"
export * from "./VActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports